import { Box } from '@mui/material';

export const routerPath = {
  root: '/bonuses',
};

export const getColumns = ({ editItem, deleteItem }) => [
  { id: 'name', label: 'Level', align: 'left' },
  { id: 'amount', label: 'Number of visits', align: 'center' },
  { id: 'credits', label: 'Bonus credits', align: 'center' },
  {
    id: 'color',
    label: 'Color',
    customValue: (item) => (
      <Box width="20px" height="20px" sx={{ backgroundColor: item.color, borderRadius: '50%', margin: '0 auto' }} />
    ),
    align: 'center',
    disableSort: true,
  },
  {
    id: 'more-menu',
    type: 'menu',
    items: [
      {
        id: 'delete',
        name: 'Delete',
        action: deleteItem,
        icon: 'eva:trash-2-outline',
        sx: { color: 'error.main' },
      },
      { id: 'edit', name: 'Edit', action: editItem, icon: 'eva:edit-fill' },
    ],
    disableSort: true,
  },
];
